const getLowercaseUserName = require('./lowercase_user_name')

module.exports = function isUser(user1, user2) {
    const user_name_1 = getLowercaseUserName(user1)
    const user_name_2 = getLowercaseUserName(user2)
    if (! user_name_1) return false
    if (! user_name_2) return false
    return user_name_1 === user_name_2
}
